import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TypeSelector from './TypeSelector';
import Editor from './Editor';

import { emptyPageElement } from "utils/pageElements/constants";

import { Dialog } from '@mui/material';

const ElementModal = ({ onSubmit, pageElement, onPageElementChange, passes, open, onClose, orgHasCalendar }) => {
  const [step, setStep] = useState(pageElement?.id ? 2 : 1);

  const handleElementSelection = (element_type) => {
    handleCreateRequest(element_type);
    setStep(2);
  };

  const handleCreateRequest = (element_type) => {
    const newElementType = element_type === "link" || element_type === "embed" ? "" : element_type;
    let newElement = { ...emptyPageElement, element_type: newElementType };

    if (element_type === "calendar") {
      newElement.settings = {
        ...emptyPageElement.settings,
        number_of_events: 3,
        view: "list",
        hide_price: false,
        hide_location: false,
      };
    }

    onPageElementChange(newElement);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth 
      maxWidth="md"
    > 

      {step === 1 && ( 
        <TypeSelector orgHasCalendar={orgHasCalendar} onSelect={handleElementSelection} onClose={onClose} />
      )}

      {step === 2 && (
        <Editor pageElement={pageElement} onPageElementChange={onPageElementChange} passes={passes} onSubmit={onSubmit} onClose={onClose} />
      )}
      
    </Dialog>
  );
};

ElementModal.propTypes = {
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  onChange: PropTypes.func,
  pageElement: PropTypes.object,
  onPageElementChange: PropTypes.func,
  passes: PropTypes.array,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  orgHasCalendar: PropTypes.bool,
};

export default ElementModal;